import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Portal, svgSprite } from '../../hybrid/wrappers';
import SingleButton from '../form/form-control-buttons/SingleButton/SingleButton';
import { t } from '../../common/components/T';
import FormComponent from '../form/FormComponent/FormComponent';
import parse from 'html-react-parser';
import css from './deletemodal.module.scss';
import classNames from 'classnames';
import { getStylePropsFunc } from '../../common/utils/styles';
import { LangContext } from '../../common/decorators/Language';

const DeleteModal = ({
    children,
    showModal,
    setShowModal,
    typeModal,
    title,
    text,
    modalFooterShow = true,
    buttons,
    customStyles = {},
    field = false,
    groupFormDataError,
    setData,
    customFieldsSettings = false,
    customFields = false
}) => {
    const allTranslations = useContext(LangContext);
    const compStyles = {
        ...css,
        ...Object.keys(customStyles).reduce((acc, key) => {
            if (css[key]) {
                if (typeof customStyles[key] === 'object') {
                    return {
                        ...acc,
                        [key]: {
                            ...customStyles[key],
                            className: classNames(customStyles[key].className, css[key])
                        }
                    };
                } else if (typeof customStyles[key] === 'string') {
                    return {
                        ...acc,
                        [key]: classNames(css[key], customStyles[key])
                    };
                }
            }
            return {
                ...acc,
                [key]: customStyles[key]
            };
        }, {})
    };
    // const { stylers, classes } = generateCompStylers(compStyles);

    const getProps = (...keys) => getStylePropsFunc(compStyles, ...keys);

    const closeHandler = () => {
        setShowModal(false);
    };

    return (
        <>
            {!!showModal && (
                <Portal customClass={typeModal || ''} closeHandler={closeHandler}>
                    <div {...getProps('modalWrapper')}>
                        <div {...getProps('modalHeader')}>
                            <p {...getProps('modalTitle')}>
                                {title || t('confirmAction-v1', 'Подтверждение действия', 'all', allTranslations?.translation)}
                            </p>
                            <div onClick={() => closeHandler()} {...getProps('modalClose')}>
                                {svgSprite('cross', {
                                    ...getProps('modalCloseSvg'),
                                    fill: 'var(--greyExtraDarkColor)'
                                })}
                            </div>
                        </div>

                        <div {...getProps('modalBody')}>
                            {!!text ? (
                                <p {...getProps('modalBodyText')}>{typeof text === 'string' ? parse(text) : text}</p>
                            ) : null}

                            {!!children && children}
                        </div>

                        {!!field && (
                            <div {...getProps('padding')}>
                                <FormComponent
                                    captcha={field?.captcha}
                                    data={[
                                        {
                                            attribute: field?.attribute,
                                            placeholder: field?.placeholder,
                                            title: field?.title
                                                ? {
                                                      body: field?.title,
                                                      text: ''
                                                  }
                                                : false,
                                            type: field?.type,
                                            value: null,
                                            ...field
                                        }
                                    ]}
                                    groupFormDataError={field?.groupFormDataError || groupFormDataError}
                                    setFormDataMain={setData || field?.setFormDataMain}
                                    sendData={{}}
                                    funcs={{}}
                                    customData={{}}
                                    buttonNotShow={true}
                                />
                            </div>
                        )}
                        {!!customFields && (
                            <div {...getProps('padding')}>
                                <FormComponent
                                    captcha={customFieldsSettings?.captcha}
                                    data={customFields}
                                    groupFormDataError={customFieldsSettings?.groupFormDataError || groupFormDataError}
                                    setFormDataMain={setData || customFieldsSettings?.setFormDataMain}
                                    sendData={{}}
                                    funcs={{}}
                                    customData={{}}
                                    buttonNotShow={true}
                                />
                            </div>
                        )}

                        {modalFooterShow && (
                            <div {...getProps('modalFooter')}>
                                <div {...getProps('modalFooterFlex')}>
                                    {buttons.map((item, idx) => (
                                        <SingleButton
                                            key={`button${idx}`}
                                            customStyles={compStyles}
                                            type={item.type}
                                            clickFunc={item.clickFunc}
                                            buttonText={
                                                item.buttonText
                                                    ? item.buttonText
                                                    : item.type === 'ok'
                                                    ? t('send', 'Отправить', 'all', allTranslations?.translation)
                                                    : t('cancel', 'Отмена', 'all', allTranslations?.translation)
                                            }
                                            // customButton={{
                                            //     ...(customStyles.singleButton
                                            //         ? {
                                            //               singleButton: customStyles.singleButton || ''
                                            //           }
                                            //         : {}),
                                            //     ...(item.type === 'ok'
                                            //         ? {
                                            //               butWrapper: {
                                            //                   className: classNames(
                                            //                       classes.formButtonPrimary,
                                            //                       classes.formButWrapper
                                            //                   ),
                                            //                   ...stylers.formButtonPrimary,
                                            //                   ...stylers.formButWrapper
                                            //               }
                                            //           }
                                            //         : {
                                            //               butWrapper: {
                                            //                   className: classes.formButWrapper,
                                            //                   ...stylers.formButWrapper
                                            //               }
                                            //           })
                                            // }}
                                        />
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>
                </Portal>
            )}
        </>
    );
};

DeleteModal.propTypes = {
    showModal: PropTypes.object,
    setShowModal: PropTypes.func,
    typeModal: PropTypes.string,
    title: PropTypes.node,
    text: PropTypes.node,
    modalFooterShow: PropTypes.bool,
    buttons: PropTypes.array,
    customStyles: PropTypes.object,
    field: PropTypes.object,
    setData: PropTypes.func,
    warningTextDelete: PropTypes.bool,
    showUserName: PropTypes.bool,
    mainMarketing: PropTypes.object
};

export default DeleteModal;
